import TCalendar from '@/components/month-calendar/month-calendar.view';
import { HeaderPortal } from '@/templates/app-shell/components/header/components/header-portal';
import { Button, ButtonGroup, Grid } from '@chakra-ui/react';
import { t } from 'i18next';
import { useMonthViewController } from './month-view.controller';

export function MonthView() {
	const { events, handlePlannerClick } = useMonthViewController();

	return (
		<>
			<HeaderPortal>
				<Grid alignContent="center" justifyContent="center" gridTemplateColumns="1fr auto" w="full" h="full" px={6}>
					<ButtonGroup isAttached></ButtonGroup>

					<ButtonGroup isAttached variant="outline">
						<Button onClick={handlePlannerClick}>{t('Planner')}</Button>
					</ButtonGroup>
				</Grid>
			</HeaderPortal>
			<TCalendar events={events || []} timeZone={'Europe/Madrid'} month={4} year={2024} />;
		</>
	);
}
